class reorderComponent extends HTMLElement {
  constructor() {
    super();
    this.summaryToggle = this.querySelector('.reorder-btn');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.addEventListener('click', this.onSummaryClick.bind(this));
    this.setAttribute('role', 'button');
  }
  //functions
  onSummaryClick(event) {
    event.preventDefault();
    this.getDetails(event);
  }
  getDetails() {
    var el = this;
    var ids = el.getAttribute('data-variant-ids').split(',');
    var productTitle = el.getAttribute('data-product-title').split(',');
    var quantities = el.getAttribute('data-variant-quantities').split(',');
    var inventories = el.getAttribute('data-variant-inventories').split(',');
    var inventory_policies = el.getAttribute('data-variant-inventory-policies').split(',');
    var inventory_trackers = el.getAttribute('data-variant-inventory-trackers').split(',');
    var variant_property = el.getAttribute('data-variant_property').split('||');
    ids.splice(-1, 1);
    productTitle.splice(-1, 1);
    quantities.splice(-1, 1);
    inventories.splice(-1, 1);
    inventory_policies.splice(-1, 1);
    inventory_trackers.splice(-1, 1);
    console.log(ids);
    var data = [];




    for (var i = 0; i < ids.length; i++) {     
      var variant_property_obj = variant_property[i].replaceAll('_',",");
      console.log(variant_property_obj);
      let tempobj=JSON.parse(`{${variant_property_obj}}`);
      data.push({
        id: ids[i],
        product_title: productTitle[i],
        quantity: quantities[i],
        inventory: inventories[i],
        properties: tempobj,
        check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
      });
    }
    el.classList.add('loading');
    var jsonObj = {};
    data.forEach(function (item) {
      console.log(item);
      jsonObj = { 'items': data, "sections": ["cart-drawer", "cart-icon-bubble"] };
    })
    console.log(this.cart);
    this.pushQueue(jsonObj, el);
  }
  pushQueue(jsonObj) {
    let thisOriginal = this;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonObj)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.log('if response status');
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.setAttribute('aria-disabled', true);
          this.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!thisOriginal.cart) {
          console.log('else if not!this cart');
          window.location = window.routes.cart_url;
          return;
        }
        thisOriginal.error = false;
        const quickAddModal = thisOriginal.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { thisOriginal.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          thisOriginal.cart.renderContents(response);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      });
  }
}
customElements.define('reorder-btn', reorderComponent); 